import React, { HTMLAttributes } from "react";

type Props = { headerText: string; skipDivider?: boolean; textColor?: string };

export default function SimpleHeader({
  headerText,
  skipDivider,
  textColor = "text-secondary",
  ...rest
}: Props & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`flex flex-col ${rest.className}`} {...rest}>
      <span className={`text-2xl font-extrabold leading-6 ${textColor}`}>
        {headerText}
      </span>
      {skipDivider != true && <div className="divider"></div>}
    </div>
  );
}
